import moment from "moment";
import { Vaccine } from "../../types/pet-screening";
import { useCallback } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

interface VaccinationTableProps {
  vaccines?: Vaccine[];
}

export const VaccinationTable = ({ vaccines }: VaccinationTableProps) => {
  const isExpired = useCallback((expirationDate?: string) => {
    return expirationDate ? moment(expirationDate).isBefore(moment()) : false;
  }, []);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-alpha-40">
        <thead>
          <tr className="h-12 text-left text-sm text-content-300">
            <th className="p-2 font-medium" colSpan={4}>
              Vaccination
            </th>
            <th className="p-2 font-medium" colSpan={3}>
              Vaccination date
            </th>
            <th className="p-2 font-medium" colSpan={3}>
              Expiration date
            </th>
            <th className="p-2 font-medium" colSpan={2}></th>
          </tr>
        </thead>
        <tbody className="divide-y text-sm divide-alpha-40">
          {vaccines?.length ? (
            vaccines.map((vaccine, index) => {
              const isVaccineExpired = isExpired(vaccine.expiration_date);

              return (
                <tr key={`vaccine-${vaccine.type}-${index}`} className="h-12">
                  <td
                    className="p-2 text-sm text-content-1000 font-medium capitalize"
                    colSpan={4}
                  >
                    {vaccine.type}
                  </td>
                  <td
                    className="p-2 text-sm font-medium text-content-300"
                    colSpan={3}
                  >
                    {vaccine.vaccination_date
                      ? moment(vaccine.vaccination_date).format("MMM D, YYYY")
                      : "--"}
                  </td>
                  <td
                    className="p-2 text-sm font-medium text-content-300"
                    colSpan={3}
                  >
                    {vaccine.expiration_date
                      ? moment(vaccine.expiration_date).format("MMM D, YYYY")
                      : "--"}
                  </td>
                  <td className="p-2" colSpan={2}>
                    <Badge
                      size={BadgeSize.SM}
                      variant={
                        isVaccineExpired
                          ? BadgeVariant.BASE
                          : BadgeVariant.SUCCESS
                      }
                    >
                      {vaccine.vaccination_date && isVaccineExpired
                        ? "Expired"
                        : "Active"}
                    </Badge>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr key="vaccine-no-vaccines" className="h-16">
              <td
                colSpan={12}
                className="p-2 text-sm text-content-300 font-medium text-center capitalize"
              >
                No vaccination records
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
